// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9a7c7c3","453":"c7333bb7","455":"c956b21b"}[chunkId] + ".chunk.js";
};